import some from 'lodash/some';
import {
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
  Component,
  EventEmitter,
  Input,
  Output,
  HostListener,
  ViewChild
} from '@angular/core';
import { IMultiSelectItem } from '../../models/i-multi-select-item';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'ui-multi-select',
  templateUrl: './ui-multi-select.component.html',
  styleUrls: ['./ui-multi-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiMultiSelectComponent implements OnChanges {
  @Input() placeholder: string;
  @Output() modelChange = new EventEmitter<IMultiSelectItem[]>();
  @Output() openChange = new EventEmitter<boolean>();
  @Output() onApply = new EventEmitter<any>();

  @ViewChild('dropdown', { static: false }) public dropdown: NgbDropdown;

  public items: IMultiSelectItem[] = [];
  private _closeTimer: any;
  public showCloseAnimation = false;
  public isSelected: boolean;

  @HostListener('mouseenter') onMouseEnter() {
    clearTimeout(this._closeTimer);
  }

  @HostListener('mouseleave') onMouseLeave() {
    this._startCloseTimer();
  }

  @Input()
  public get model() {
    return this.items;
  }

  public set model(items: IMultiSelectItem[]) {
    this.items = items;
  }

  ngOnChanges(changes: SimpleChanges) {
    this._checkSelectedItems();
  }

  public dropdownOpenChange(isOpen: boolean) {
    this.showCloseAnimation = !isOpen;

    this.openChange.emit(isOpen);
    if (!isOpen) {
      this.onApply.emit();
    }
  }

  public itemModelChange(item, event) {
    item.checked = event;
    this._checkSelectedItems();
    this.modelChange.emit(this.items);
  }

  private _startCloseTimer() {
    clearTimeout(this._closeTimer);

    this._closeTimer = setTimeout(() => {
      this.dropdown.close();
    }, 800);
  }

  private _checkSelectedItems() {
    this.isSelected = some(this.items, (item) => item.checked);
  }
}
